<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link"><router-link to="/loja" class="fa fa-home"></router-link></li>
          <li class="item-link"><router-link to="/login" class="wrap-breadcrumb ul span">Login</router-link></li>
          <li class="item-link"><span>Cadastro</span></li>
        </ul>
      </div>
      <div class="main-content-area">
        <div>
          <div class="row">
            <div class="col-md-12">
              <form @submit.prevent="register" action="#" method="get" name="frm-billing">
                <!-- Dados da Empresa -->
                <div class="row">
                  <div class="col-md-12">
                    <h3 class="box-title">Cadastro</h3>
                  </div>
                </div>

                <div class="row">
                  <div v-if="loadingCnpj" class="col-md-12">
                    <Loader style="margin-top: 20px" />
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.cnpj"
                      :form="formRegister"
                      validationType="cnpj"
                      label="CNPJ"
                      mask="##.###.###/####-##"
                      :disabled="true"
                    ></FormHelper>
                  </div>

                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.razaoSocial"
                      :form="formRegister"
                      maxlength="60"
                      label="Razão Social"
                      :disabled="disabledRazaoSocial"
                    ></FormHelper>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.telefoneCelular"
                      validationType="phone"
                      :form="formRegister"
                      maxlength="16"
                      label="Celular/WhatsApp Responsável da Empresa"
                      placeholder="(99) 99999-9999"
                      icon="fa-phone"
                      :mask="['(##) #########']"
                    ></FormHelper>
                  </div>

                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.celular"
                      validationType="phone"
                      :form="formRegister"
                      maxlength="16"
                      label="Celular/WhatsApp Setor Compras"
                      placeholder="(99) 99999-9999"
                      icon="fa-phone"
                      :mask="['(##) #########']"
                    ></FormHelper>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.nomeQuemCadastrou"
                      :form="formRegister"
                      maxlength="60"
                      label="Nome do Responsável pelo Cadastro"
                    ></FormHelper>
                  </div>

                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.email"
                      :form="formRegister"
                      validationType="email"
                      label="E-mail"
                      placeholder="Ex.: contato@empresa.com.br"
                      icon="fa-envelope"
                    ></FormHelper>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.cpfSocio"
                      :form="formRegister"
                      validationType="cpf"
                      label="CPF do Sócio ou Propretário"
                      mask="###.###.###-##"
                    ></FormHelper>
                  </div>

                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.nomeSocio"
                      :form="formRegister"
                      validationType="quotes"
                      maxlength="60"
                      label="Nome do Sócio ou Propretário"
                      placeholder="Informe o Nome do Sócio ou Propretário"
                      :disabled="disabledNomeSocio"
                    ></FormHelper>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.senha"
                      :form="formRegister"
                      validationType="password"
                      type="password"
                      label="Senha"
                      icon="fa-eye"
                    ></FormHelper>
                  </div>

                  <div class="col-md-6">
                    <FormHelper
                      :inputVar="formRegister.confirmaSenha"
                      :form="formRegister"
                      type="password"
                      label="Confirme a Senha"
                      icon="fa-eye"
                    ></FormHelper>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="alert-group">
                      <div class="alert alert-info alert-dismissable">
                        <p>A senha deve possuir no mínimo 8 caracteres, letras maiúsculas, minúsculas e números.</p>
                      </div>
                    </div>
                  </div>
                </div>

                <br />

                <div v-if="formRegister.attemptSubmit && formErrors > 0" class="row">
                  <div class="col-md-12">
                    <div class="form-errors alert alert-danger" role="alert">
                      <i class="fa fa-warning"></i>
                      Seu formulário possui {{ formErrors }} erros. Por favor, corrija antes de prosseguir.
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <input style="margin: 5px; margin-bottom: 16px" id="terms" type="checkbox" v-model="formRegister.termos" />
                    <label for="terms"
                      >Li e concordo com os <strong><a href="https://www.aldo.com.br/termos-de-uso" target="_blank"> Termos de uso</a></strong></label
                    >
                  </div>
                  <div class="col-md-12">
                    <input style="margin: 5px; margin-bottom: 26px" id="politica" type="checkbox" v-model="formRegister.politica" />
                    <label for="politica"
                      >Li e concordo com a
                      <strong
                        ><a href="https://www.aldo.com.br/blog/politica-de-privacidade" target="_blank">Política de privacidade</a></strong
                      ></label
                    >
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-2">
                    <button
                      aria-label="Salvar cadastro simplificado"
                      class="btn btn-primary"
                      type="submit"
                      :disabled="(formRegister.attemptSubmit && formErrors > 0) || loadingRegister"
                    >
                      Salvar cadastro
                    </button>
                  </div>
                  <div v-if="loadingRegister" class="col-md-6">
                    <Loader />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import FormHelper from './partials/FormHelper.vue'
import axios from 'axios'

export default {
  name: 'Register',
  data() {
    return {
      loadingCnpj: false,
      requiredFieldMessage: 'Por favor, preencha o campo acima',
      atividadesSecundarias: [],
      cep: '',
      endereco: '',
      numero: '',
      complemento: '',
      cnae: '',
      fundacao: '',
      telefone: '',
      bairro: '',
      nomeFantasia: '',
      estado: '',
      cidade: '',
      disabledRazaoSocial: true,
      disabledNomeSocio: false,
      formRegister: {
        attemptSubmit: false,
        cnpj: new this.$formInput(true, this.$route.params.cnpj),
        razaoSocial: new this.$formInput(false),
        cpfSocio: new this.$formInput(),
        nomeSocio: new this.$formInput(),
        telefoneCelular: new this.$formInput(),
        celular: new this.$formInput(),
        email: new this.$formInput(),
        senha: new this.$formInput(),
        confirmaSenha: new this.$formInput(),
        termos: false,
        politica: false,
        nomeQuemCadastrou: new this.$formInput()
      },
      socios: [],
      temInfosCnpj: false,
      temInfosFinancialCnpj: false,
      regimeTributario: null,
      inscricaoEstadual: '',
      situacaoCnpj: '',
      situacaoIe: '',
      loadingRegister: false,
      recoverPwd: false
    }
  },
  components: {
    FormHelper
  },
  mounted() {
    this.loadingCnpj = true
    const precadastroString = localStorage.getItem('precadastro')

    if (precadastroString) {
      const precadastro = JSON.parse(precadastroString)
      this.formRegister.razaoSocial.value = precadastro.razaoSocial
      this.formRegister.telefoneCelular.value = precadastro.telefoneCelular
      this.formRegister.celular.value = precadastro.celular
      this.formReister.nomeQuemCadastrou.value = precadastro.Cli_Comprador
      this.formRegister.email.value = precadastro.email
      this.formRegister.cpfSocio.value = precadastro.cpfSocio
      this.formRegister.nomeSocio.value = precadastro.nomeSocio
      this.cep = precadastro.cep
      this.endereco = precadastro.endereco
      this.numero = precadastro.numero
      this.complemento = precadastro.complemento
      this.cnae = precadastro.cnae
      this.atividadesSecundarias = precadastro.atividadesSecundarias
      this.fundacao = precadastro.fundacao
      this.telefone = precadastro.telefone
      this.bairro = precadastro.bairro
      this.nomeFantasia = precadastro.nomeFantasia
      this.cidade = precadastro.cidade
      this.estado = precadastro.estado

      this.recoverPwd = true

      return
    }

    this.loadingCnpj = true
    this.getByCnpj(this.$route.params.cnpj)
  },
  computed: {
    formErrors: function () {
      // Retorna os campos que estão com erro de validação
      const errors = Object.keys(this.formRegister).filter(
        (key) => this.formRegister[key].required && this.formRegister[key].validation && !this.formRegister[key].validation.status
      )

      let errorsSocio = []
      if (this.hasPartners && this.socios.length == 0) {
        errorsSocio = Object.keys(this.formSocio).filter(
          (key) => this.formSocio[key].required && this.formSocio[key].validation && !this.formSocio[key].validation.status
        )
      }
      return errorsSocio.length + errors.length
    }
  },
  methods: {
    removeAcento(text) {
      text = text.toLowerCase()
      text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a')
      text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e')
      text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i')
      text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o')
      text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u')
      text = text.replace(new RegExp('[Ç]', 'gi'), 'c')
      return text
    },
    getByCnpj(cnpj) {
      this.loadingCnpj = true

      var xhr = new XMLHttpRequest()
      xhr.onload = () => {
        this.loadingCnpj = false
        if (xhr.status == 200) {
          var result = JSON.parse(xhr.responseText)
          if (result.Item1 == true) {
            location.href = result.Item2 == 1 ? '/login' : '/cadastro/' + this.$route.params.cnpj
          } else {
            this.getInfosCnpj(cnpj)
            this.getInfosFinancialCnpj(cnpj)
          }
        } else {
          swal({
            title: 'Erro ao verificar CNPJ',
            icon: 'warning'
          })
        }
      }

      xhr.open('POST', this.$apiUrl + 'ClientePre.svc/verificacnpj')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(JSON.stringify({ cnpj: cnpj }))
    },
    getInfosFinancialCnpj(cnpj) {
      this.loadingCnpj = true
      axios
        .get(`${this.$apiUrl}Cliente.svc/infos-financeiras-cnpj/${cnpj}/R`)
        .then((response) => {
          this.loadingCnpj = false

          if (response.data) {
            let infosFinanceiras = response.data
            if (infosFinanceiras.regime_tributacao) {
              let regimeTributario = infosFinanceiras.regime_tributacao.split('-')[0].trim()
              regimeTributario = this.getTaxRegimeOptions().filter((c) => c.label.toLowerCase().includes(regimeTributario.toLowerCase()))[0]
              if (regimeTributario) this.regimeTributario = regimeTributario.code
            }
            this.inscricaoEstadual = infosFinanceiras.inscricao_estadual
            this.situacaoCnpj = infosFinanceiras.situacao_cnpj
            this.situacaoIe = infosFinanceiras.situacao_ie

            this.temInfosFinancialCnpj = true
          } else {
            this.temInfosFinancialCnpj = false
          }
        })
        .catch((e) => {
          console.log(e)
          this.loadingCnpj = false
          this.temInfosFinancialCnpj = false
        })
    },
    getInfosCnpj(cnpj) {
      this.loadingCnpj = true
      axios
        .get(this.$apiUrl + `Cliente.svc/infos-cnpj/${cnpj}/R`)
        .then((response) => {
          this.loadingCnpj = false
          let empresa = response.data

          if (!(empresa.code == '0')) {
            swal({
              title: 'Não foi possível validar seu CNPJ',
              text: empresa.message,
              icon: 'warning'
            }).then((confirm) => {
              if (confirm) {
                this.disabledRazaoSocial = false
                this.disabledNomeSocio = false
                this.formRegister.complementoDisabled = false
                this.formRegister.nomeFantasiaDisabled = false
                this.temInfosCnpj = false
              }
            })
          } else {
            this.formRegister.razaoSocial.value = empresa.nome.replace(/[,"']/g, '').slice(0, 60)
            this.nomeFantasia = empresa.fantasia.replace(/[,"']/g, '').slice(0, 60)
            this.cep = empresa.cep
            this.endereco = empresa.logradouro.slice(0, 60)
            this.numero = empresa.numero
            this.complemento = empresa.complemento.slice(0, 60)
            this.cnae = empresa.atividade_principal[0].code
            this.atividadesSecundarias = empresa.atividades_secundarias
            this.fundacao = empresa.data_situacao
            let telefones = empresa.telefone.split('/')
            this.telefone = telefones[0].trim()
            this.celular = telefones[1].trim()
            this.bairro = empresa.bairro.slice(0, 60)
            this.cidade = empresa.municipio

            const estados = this.getStates()
            const estado = estados.filter((c) => c.code == empresa.uf)[0]
            this.estado = estado != null ? estado.code : ''

            if (empresa.qsa.length > 0 && empresa.qsa[0].nome != '') {
              empresa.qsa.forEach((element, index) => {
                let socio = {}

                if (index == 0) this.formRegister.nomeSocio.value = element.nome.slice(0, 60)

                socio.PresocNome = element.nome.slice(0, 60)
                socio.PresocCargo = element.qual === null ? '' : element.qual.slice(0, 60).slice(3).trim()
                this.socios.push(socio)
              })
            } else {
              this.disabledNomeSocio = false
            }

            this.temInfosCnpj = true
          }
        })
        .catch((e) => {
          console.log(e)
          swal({
            title: 'CNPJ não cadastrado e/ou encontrado na receita',
            icon: 'warning'
          })
          this.temInfosCnpj = false
        })
    },
    register: function () {
      this.formRegister.attemptSubmit = true

      if (!this.validarFormulario()) return

      const obj = this.getCadastroSimplificado()

      if (this.formErrors === 0) {
        this.loadingRegister = true
        const xhr = new XMLHttpRequest()

        xhr.onload = () => {
          this.loadingRegister = false
          if (xhr.status == 200) {
            localStorage.removeItem('precadastro')
            swal({
              title: 'Cliente cadastrado com sucesso',
              icon: 'success'
            }).then(() => (location.href = '/login'))
          } else if (xhr.status == 201) {
            localStorage.removeItem('precadastro')
            localStorage.removeItem('usuarioLogado')
            swal({
              title: 'Pré-cadastro concluído com sucesso',
              text: 'Finalize o preenchimento dos demais dados cadastrais na próxima página.',
              icon: 'success'
            }).then(() => (location.href = '/cadastro/' + this.$route.params.cnpj))
          } else if (xhr.status == 205) {
            swal({
              title: 'Cliente já possui cadastro na Aldo:\r\n' + obj.PreCnpj,
              icon: 'warning'
            })
          } else if (xhr.status == 412) {
            swal({
              title: 'Seu cadastro está em processo de aprovação',
              text: 'Por favor, aguarde a confirmação para acessar sua conta. O processo de aprovação deve ser concluído em até um dia útil.',
              icon: 'warning'
            }).then(() => (location.href = '/login'))
          } else if (xhr.status == 413) {
            swal({
              title: 'Arquivo muito grande, tente usar arquivos menores que 2,5mb.',
              icon: 'warning'
            })
          } else {
            swal({
              title: 'Ops! Algo deu errado, tente novamente em alguns instantes.',
              text: xhr.status + ' - ' + xhr.statusText,
              icon: 'error'
            })
          }
        }

        xhr.open('POST', this.$apiUrl + 'ClientePre.svc/concluircadastro')
        xhr.setRequestHeader('Content-Type', 'application/json')
        xhr.withCredentials = true
        xhr.send(JSON.stringify(obj))
      }
    },

    validarFormulario() {
      if (this.formRegister.senha.value !== this.formRegister.confirmaSenha.value) {
        swal({
          title: 'A confirmação de senha não confere.',
          icon: 'warning'
        })
        return false
      }

      if (!this.formRegister.termos) {
        swal({
          title: 'Para finalizar o cadastro é necessário aceitar os termos de uso.',
          icon: 'warning'
        })
        return false
      }

      if (!this.formRegister.politica) {
        swal({
          title: 'Para finalizar o cadastro é necessário aceitar a política de privacidade.',
          icon: 'warning'
        })
        return false
      }

      return true
    },

    getCadastroSimplificado() {
      const dataFundacaoString = this.fundacao.split('/')
      const data = new Date(dataFundacaoString[2] + '-' + dataFundacaoString[1] + '-' + dataFundacaoString[0] + 'T00:00:00')
      const preFundacao = data.getTime()

      let obj = {}

      obj.PreCnpj = this.formRegister.cnpj.value
      obj.PreRazaosocial = this.formRegister.razaoSocial.value
      obj.PreTelefoneCelular = this.formRegister.telefoneCelular.value
      obj.PreTelefone = this.formRegister.celular.value
      obj.Cli_Comprador = this.formRegister.nomeQuemCadastrou.value
      obj.PreEmail = this.formRegister.email.value
      obj.PreSenha = this.formRegister.senha.value

      obj.PreCep = this.cep
      obj.PreEndereco = this.endereco
      obj.PreNumeroendereco = this.numero
      obj.PreComplementoendereco = this.complemento
      obj.CliCnae = this.cnae
      obj.PreFundacao = this.fundacao != '' ? '/Date(' + preFundacao + '-0300)/' : null
      obj.PreTelefone = this.telefone
      obj.PreBairro = this.bairro
      obj.PreNomefantasia = this.nomeFantasia
      obj.EstUf = this.estado
      obj.PreCidade = this.cidade
      obj.AtividadesSecundarias = this.atividadesSecundarias
      obj.PreCadastroCompleto = this.temInfosCnpj && this.temInfosFinancialCnpj ? 1 : 0
      obj.CliLucroreal = this.regimeTributario
      obj.PreIe = this.inscricaoEstadual
      obj.PreReceitaStatus = 'P'
      obj.PreMei = 1
      obj.PreImpedircadastro = 'N'

      if (obj.PreCadastroCompleto === 1) {
        if (
          this.situacaoCnpj &&
          this.situacaoIe &&
          (this.situacaoCnpj.toUpperCase() === 'ATIVO' || this.situacaoCnpj.toUpperCase() === 'SEM RESTRIÇÃO') &&
          this.situacaoIe.toUpperCase() === 'ATIVO'
        ) {
          obj.PreReceitaStatus = 'V'
        } else {
          obj.PreImpedircadastro = 'S'
          const textoSituacaoCnpj = !this.situacaoCnpj ? 'NÃO ENCONTRADO' : this.situacaoCnpj.toUpperCase()
          const textoSituacaoIe = !this.situacaoIe ? 'NÃO ENCONTRADO' : this.situacaoIe.toUpperCase()
          const msgSintegra = !(this.situacaoCnpj && this.situacaoIe) ? ` - ${this.message}` : ''
          obj.PreObservacao = `ATUALIZACAO AUTOMATICA - SINTEGRAWS - CNPJ: ${textoSituacaoCnpj} | IE: ${textoSituacaoIe}${msgSintegra}`
        }
      }

      if (!this.socios[0]) this.socios[0] = {}

      this.socios[0].PresocCpf = this.formRegister.cpfSocio.value
      this.socios[0].PresocNome = this.formRegister.nomeSocio.value

      obj.Clientesprecadastrossocios = this.socios

      return obj
    },

    getStates: function () {
      // TODO: Fazer ajax para busca de estados
      const states = [
        {
          code: 'AC',
          label: 'Acre'
        },
        {
          code: 'AL',
          label: 'Alagoas'
        },
        {
          code: 'AP',
          label: 'Amapá'
        },
        {
          code: 'AM',
          label: 'Amazonas'
        },
        {
          code: 'BA',
          label: 'Bahia'
        },
        {
          code: 'CE',
          label: 'Ceará'
        },
        {
          code: 'DF',
          label: 'Distrito Federal'
        },
        {
          code: 'ES',
          label: 'Espírito Santo'
        },
        {
          code: 'GO',
          label: 'Goiás'
        },
        {
          code: 'MA',
          label: 'Maranhão'
        },
        {
          code: 'MT',
          label: 'Mato Grosso'
        },
        {
          code: 'MS',
          label: 'Mato Grosso do Sul'
        },
        {
          code: 'MG',
          label: 'Minas Gerais'
        },
        {
          code: 'PA',
          label: 'Pará'
        },
        {
          code: 'PB',
          label: 'Paraíba'
        },
        {
          code: 'PR',
          label: 'Paraná'
        },
        {
          code: 'PE',
          label: 'Pernambuco'
        },
        {
          code: 'PI',
          label: 'Piauí'
        },
        {
          code: 'RJ',
          label: 'Rio de Janeiro'
        },
        {
          code: 'RN',
          label: 'Rio Grande do Norte'
        },
        {
          code: 'RS',
          label: 'Rio Grande do Sul'
        },
        {
          code: 'RO',
          label: 'Rondônia'
        },
        {
          code: 'RR',
          label: 'Roraima'
        },
        {
          code: 'SC',
          label: 'Santa Catarina'
        },
        {
          code: 'SP',
          label: 'São Paulo'
        },
        {
          code: 'SE',
          label: 'Sergipe'
        },
        {
          code: 'TO',
          label: 'Tocantins'
        }
      ]

      return states
    },

    getTaxRegimeOptions: function () {
      const taxRegime = [
        { code: 0, label: 'Lucro Real' },
        { code: 2, label: 'Simples Nacional' },
        { code: 3, label: 'Lucro Arbitrado' },
        { code: 4, label: 'Lucro Presumido' }
      ]

      return taxRegime
    }
  }
}
</script>
